import React from "react";
import { CustomButton, IconComponent, CircularLoader, CustomSwitch, icon } from "../../../../common/components";
import { translate } from "../../../../common/providers";
import TemplateDialog from "./TemplateDialog";
import styles from "./DeliverableSidePanel.module.css";

export default function ImportView({
	fileInputRef,
	selectedFile,
	importErrors,
	shouldErase,
	isUploading,
	templateHeaders,
	showTemplateTable,
	onFileSelect,
	onImport,
	onCancel,
	onSetShouldErase,
	onSetShowTemplateTable,
	onShowTemplate,
	onDownloadTemplate,
	onKeyDown,
}) {
	return (
		<div className={styles.sidePanelContent}>
			<div className={styles.infoBox}>
				<div className={styles.infoContent}>
					<div className={styles.infoTitle}>{translate("deliverables-list.import_description")}</div>
					<div className={styles.infoTextBlock}>
						<div className={styles.infoText}>
							{translate("deliverables-list.import_description_text_1")}
						</div>
						<div className={styles.infoText}>
							{translate("deliverables-list.import_description_text_2")}
							<span
								className={styles.linkText}
								role="button"
								tabIndex={0}
								onClick={onShowTemplate}
								onKeyDown={onKeyDown(onShowTemplate)}
							>
								{translate("deliverables-list.import_specific_format")}
							</span>
							.
						</div>
						<div className={styles.infoText}>
							{translate("deliverables-list.import_description_text_3")}
							<span
								className={styles.linkText}
								role="button"
								tabIndex={0}
								onClick={onDownloadTemplate}
								onKeyDown={onKeyDown(onDownloadTemplate)}
							>
								{translate("deliverables-list.import_at_this_address")}
							</span>
						</div>
					</div>
					<div className={styles.infoInstructions}>{translate("deliverables-list.import_instructions")}</div>
				</div>
			</div>

			<div className={styles.importSection}>
				{!selectedFile ? (
					<div className={styles.fileUploadArea}>
						<IconComponent color="var(--blue-500)" icon={icon.faCloudArrowDown} size="5xl" />
						<CustomButton
							component="label"
							htmlFor="file-upload"
							startIcon={icon.faPlus}
							variant="contained"
						>
							{translate("deliverables-list.import_button_select")}
							<input
								ref={fileInputRef}
								hidden
								accept=".xls,.xlsx"
								id="file-upload"
								type="file"
								onChange={onFileSelect}
							/>
						</CustomButton>
						<div className={styles.uploadText}>{translate("deliverables-list.import_file_format")}</div>
					</div>
				) : (
					<>
						<div className={styles.fileSelected}>
							<IconComponent color="var(--blue-500)" icon={icon.faCloudArrowDown} size="5xl" />
							<div className={styles.fileDetails}>
								<div className={styles.fileLabel}>
									{translate("deliverables-list.import_file_imported")}
								</div>
								<div className={styles.fileName}>{selectedFile.name}</div>
							</div>
							{importErrors && importErrors.length > 0 && (
								<>
									<div className={styles.errorSection}>
										<div className={styles.errorTitle}>
											{translate("deliverables-list.import_errors_identified")}
										</div>
										<div className={styles.errorList}>
											{importErrors.map((error) => (
												<div key={error} className={styles.errorText}>
													{error}
												</div>
											))}
										</div>
									</div>
									<CustomButton
										component="label"
										htmlFor="file-upload-retry"
										startIcon={icon.faPlus}
										variant="outlined"
									>
										{translate("deliverables-list.import_select_other_file")}
										<input
											hidden
											accept=".xls,.xlsx"
											id="file-upload-retry"
											type="file"
											onChange={onFileSelect}
										/>
									</CustomButton>
								</>
							)}
						</div>
					</>
				)}
			</div>
			{selectedFile && (!importErrors || importErrors.length === 0) && (
				<div className={styles.dangerZone}>
					<div className={styles.dangerContent}>
						<div className={styles.dangerTitle}>{translate("deliverables-list.import_danger_zone")}</div>
						<label className={styles.checkboxLabel} htmlFor="erase-checkbox">
							<CustomSwitch
								checked={shouldErase}
								size="small"
								onChange={(e) => onSetShouldErase(e.target.checked)}
							/>
							<span>{translate("deliverables-list.import_reinitialize")}</span>
						</label>
					</div>
				</div>
			)}
			<div className={styles.actionButtons}>
				<CustomButton variant="outlined" onClick={onCancel}>
					{translate("deliverables-list.actions.cancel")}
				</CustomButton>
				<CustomButton
					disabled={!selectedFile || isUploading || importErrors}
					variant="contained"
					onClick={onImport}
				>
					{isUploading && <CircularLoader size={16} />}
					{translate("deliverables-list.actions.validate")}
				</CustomButton>
			</div>
			<TemplateDialog
				open={showTemplateTable}
				templateHeaders={templateHeaders}
				onClose={() => onSetShowTemplateTable(false)}
			/>
		</div>
	);
}
